module.exports = __webpack_public_path__ + "img/family.3bd0d997.webp";